import { ReactNode, type InputHTMLAttributes, forwardRef } from 'react';

import { UseFormRegisterReturn } from 'react-hook-form';
import { NationMenuItem } from '@/types/order';
import NationSelect from '../NationSelect';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  errorMessage?: string;
  containerClassName?: string;
  register?: UseFormRegisterReturn;
  letterLabel?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, errorMessage, containerClassName, className, register, type = 'text', letterLabel, ...inputProps }, ref) => {
    // ref 병합 함수
    const setRef = (el: HTMLInputElement | null) => {
      if (typeof ref === 'function') {
        ref(el);
      } else if (ref && 'current' in ref) {
        ref.current = el;
      }

      if (register?.ref) {
        register.ref(el);
      }
    };

    return (
      <div className={`flex flex-col relative gap-2 ${containerClassName ? ` ${containerClassName}` : ''}`}>
        {label && <span className="text-[14px] font-semibold">{label}</span>}
        <input
          {...inputProps}
          {...register}
          ref={setRef}
          type={type}
          className={`${
            errorMessage ? 'border-[#e52e2e] focus:ring-[#e52e2e]' : 'border-[#E0E0E0]'
          } placeholder:text-[#E0E0E0] text-[14px] leading-5 font-semibold h-[54px] rounded-[10px] border px-4 outline-none focus:ring-1 transition-colors ${
            className ? ` ${className}` : ''
          }`}
        />
        {errorMessage && (
          <span className="text-[13px] leading-[18px] font-medium text-[#e52e2e] absolute top-[60px]">{errorMessage}</span>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

interface InputWithMenuProps extends InputProps {
  menuClassName?: string;
  menus: NationMenuItem[];
  onMenuSelect?: (value: string, codeNumber: string) => void;
  defaultValue?: string;
  inputContainerClassName?: string;
  menuValue?: string;
}

export const InputWithMenu = ({
  menuClassName,
  menus,
  onMenuSelect,
  menuValue,
  defaultValue,
  inputContainerClassName,
  label,
  errorMessage,
  containerClassName,
  ...inputProps
}: InputWithMenuProps) => (
  <div className={`flex flex-col relative gap-2${containerClassName ? ` ${containerClassName}` : ''}`}>
    {label && <span className="text-[14px] font-semibold">{label}</span>}
    <div className="flex flex-row gap-4">
      <NationSelect menus={menus ?? []} menuClassName={menuClassName} onMenuSelect={onMenuSelect} menuValue={menuValue} />
      <Input {...inputProps} containerClassName={inputContainerClassName} type={'number'} />
    </div>
    {errorMessage && (
      <span className="text-[13px] leading-[18px] font-medium text-[#e52e2e] absolute top-[60px]">{errorMessage}</span>
    )}
  </div>
);

export default Input;
